import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { CalendarItem } from 'ui/calendar'
import SpecialDaysCalendar from 'widgets/shifts/SpecialDaysCalendar'
import { ForEachModel, Model } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import CalendarPeriod from 'widgets/CalendarPeriod'
import MonthFilterSyncedWithModel from 'support/filters/MonthFilterSyncedWithModel'
import { PageHeader } from 'ui'
import { SelectedDepartmentFilter } from 'support/filters'
import { TableHeader } from 'ui/table'
import CreateSpecialDaySmartview from 'widgets/smartviews/shifts/CreateSpecialDaySmartview'
import { Can } from '@morningtrain/react-auth'
import AdminPage from 'pages/app/AdminPage'
import Permissions from 'services/Permissions'
import WithModelValue from 'support/utilities/WithModelValue'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'

export default function SpecialDays (props) {
  return (
    <>
      <Can permission={Permissions.OPERATIONS_SPECIALDAYS_MANAGE}>
        <AdminPageWithSmartview>
          <Model resourceName='shifts.special_days' operationName='month' clean>
            <PageHeader title={<CalendarPeriod/>}/>
            <TableHeader>
              <MonthFilterSyncedWithModel/>
              <SelectedDepartmentFilter/>
            </TableHeader>
            <hr className='mb-4'/>
            <SpecialDaysCalendar>
              <CalendarItem>
                <ForEachModel>
                  <WithModelValue name='id'>
                    {id => (
                      <MountSmartviewOnClick smartview={<CreateSpecialDaySmartview id={id}/>} replace={false}>
                        <div>
                          <Displays.Text name='name'/>
                        </div>
                      </MountSmartviewOnClick>
                    )}
                  </WithModelValue>
                </ForEachModel>
              </CalendarItem>
            </SpecialDaysCalendar>
          </Model>
        </AdminPageWithSmartview>
      </Can>
      <Can permission={Permissions.OPERATIONS_SPECIALDAYS_MANAGE} negate>
        <Can permission={Permissions.OPERATIONS_SPECIALDAYS_VIEW}>
          <AdminPage>
            <Model resourceName='shifts.special_days' operationName='month' clean>
              <PageHeader title={<CalendarPeriod/>}/>
              <TableHeader>
                <MonthFilterSyncedWithModel/>
                <SelectedDepartmentFilter/>
              </TableHeader>
              <hr className='mb-4'/>
              <SpecialDaysCalendar>
                <CalendarItem>
                  <ForEachModel>
                    <div>
                      <Displays.Text name='name'/>
                    </div>
                  </ForEachModel>
                </CalendarItem>
              </SpecialDaysCalendar>
            </Model>
          </AdminPage>
        </Can>
      </Can>
    </>
  )
}
